import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Pastelería Nina | La vida sabe a Nina';
  isLoading: boolean = false;

  toggleLoader(show: boolean): void {
    this.isLoading = show;
  }
  
  constructor(private router: Router ,private gtmService: GoogleTagManagerService) {
     this.gtmService.addGtmToDom();
   }
  
  ngOnInit(): void {
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
          const gtmTag = {
              event: 'page',
              pageName: item.url
          };

          this.gtmService.pushTag(gtmTag);
      }
    });
   }
}
